import { styled } from "@mui/material";

const EditorContainer = styled("div", {
  shouldForwardProp: (prop) => prop !== "height" && prop !== "width",
})<{ height: string | number; width: string | number }>(({ height, width }) => ({
  height,
  width,
}));

export { EditorContainer };
